import type { FC } from "react";
import { Fragment } from "react";

interface Props {
  assigneeStatus: any;
  requestStatus: any;
}
/**
 * 
 * @param props requestState: submitted | inProgress | rejected | completed
 * @returns 
 */
const AssigneeStatus: FC<Props> = (props) => {
  const { assigneeStatus, requestStatus } = props;

  return (
    <Fragment>
      {assigneeStatus === requestStatus.submitted && (
        <span className="flag default">Chưa thực hiện yêu cầu</span>
      )}
      {assigneeStatus === requestStatus.inProgress && (
        <span className="flag info">Đang thực thi</span>
      )}
      {assigneeStatus === requestStatus.rejected && <span className="flag danger">Đã từ chối</span>}
      {assigneeStatus === requestStatus.completed && (
        <span className="flag success">Đã thực hiện yêu cầu</span>
      )}
    </Fragment>
  );
};

export default AssigneeStatus;
